__turbopack_context__.v({
  "className": "I5fuCG_className",
  "variable": "I5fuCG_variable",
});
